/* eslint-disable */ import { assertNumber, attributeSelectionComponent, memoEval, sceneEntityObjectRemoteMaterialOverrideComponent, sceneEntityPropertiesComponent, violationComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { EdgeFinish, FenixVariant, TopFinish, TopMaterial } from '../model/index.js';
export const topComponents = [
    attachComponent.withComponent(violationComponent, 'default', true).withAlias('Top').attach(memoEval((s)=>[
            s.$violations
        ], (violations)=>{
        return {
            violations
        };
    })),
    attachComponent.withComponent(sceneEntityPropertiesComponent, 'default', true).withAlias('Top').attach(memoEval((self)=>[
            self.$offsetY
        ], ($offsetY)=>({
            offsetY: $offsetY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'body', true).withAlias('Top').attach(memoEval((self)=>[
            self.$materialToOverride,
            self.$materialColor,
            self.$textureUrl,
            self.$normalMapUrl,
            self.$roughnessMapUrl,
            self.$roughness,
            self.$normalScale,
            self.$envMapIntensity,
            self.$repeatX,
            self.$repeatY
        ], ($materialToOverride, $materialColor, $textureUrl, $normalMapUrl, $roughnessMapUrl, $roughness, $normalScale, $envMapIntensity, $repeatX, $repeatY)=>({
            materialsToOverride: $materialToOverride,
            fileUrl: '/models/algu3d.glb',
            materialName: 'TableTopMaterial',
            color: $materialColor,
            textureUrl: $textureUrl,
            normalMapUrl: $normalMapUrl,
            roughnessMapUrl: $roughnessMapUrl,
            roughness: $roughness,
            normalScale: $normalScale,
            envMapIntensity: $envMapIntensity,
            repeatX: $repeatX,
            repeatY: $repeatY
        }))),
    attachComponent.withComponent(attributeSelectionComponent, 'thickness', true).withAlias('Top').attach(memoEval((self)=>[
            self.thickness,
            self.$thicknessOptions
        ], (thickness, $thicknessOptions)=>({
            value: thickness,
            options: $thicknessOptions
        })), (state)=>{
        assertNumber(state.value);
        return {
            thickness: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'edgeFinish', true).withAlias('Top').attach(memoEval((self)=>[
            self.edgeFinish,
            self.$edgeFinishOptions
        ], (edgeFinish, $edgeFinishOptions)=>({
            value: edgeFinish,
            options: $edgeFinishOptions
        })), (state)=>{
        EdgeFinish.assert(state.value);
        return {
            edgeFinish: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'topFinish', true).withAlias('Top').attach(memoEval((self)=>[
            self.topFinish,
            self.$topFinishOptions
        ], (topFinish, $topFinishOptions)=>({
            value: topFinish,
            options: $topFinishOptions
        })), (state)=>{
        TopFinish.assert(state.value);
        return {
            topFinish: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'fenixVariant', true).withAlias('Top').attach(memoEval((self)=>[
            self.fenixVariant,
            self.$fenixVariantOptions
        ], (fenixVariant, $fenixVariantOptions)=>({
            value: fenixVariant,
            options: $fenixVariantOptions
        })), (state)=>{
        FenixVariant.assert(state.value);
        return {
            fenixVariant: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'topMaterial', true).withAlias('Top').attach(memoEval((self)=>[
            self.material,
            self.$topMaterialOptions
        ], (material, $topMaterialOptions)=>({
            value: material,
            options: $topMaterialOptions
        })), (state)=>{
        TopMaterial.assert(state.value);
        return {
            material: state.value
        };
    })
];

//# sourceMappingURL=top.js.map